import { render, staticRenderFns } from "./Plantillas.vue?vue&type=template&id=5447c6f6&"
import script from "./Plantillas.vue?vue&type=script&lang=js&"
export * from "./Plantillas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports